import { fromJS } from 'immutable';
import MODULE_NAME from '../constants/moduleName';

export const SET_SEARCH_SUBMITTING = `modules/${MODULE_NAME}/SET_SEARCH_SUBMITTING`;

export const initialState = fromJS({
  isSubmitting: false,
});

// eslint-disable-next-line default-param-last -- this is required
export default function reducer(state = initialState, action) {
  switch (action?.type) {
    case SET_SEARCH_SUBMITTING: {
      return state.set('isSubmitting', action.isSubmitting);
    }
    default:
      return state;
  }
}
